import { Lock, Pencil } from "lucide-react";
import { buttonVariants } from "./button";
import { cn } from "./utils";

export interface EditPencilProps {
    /** Show the padlock (ghost) instead of the pencil. */
    locked?: boolean;
    className?: string;
}

/**
 * The edit affordance used everywhere (profile page style): a round secondary icon button.
 * Purely visual - wrap it in a button, link or role="button" element that handles the click.
 */
export function EditPencil({ locked = false, className }: EditPencilProps) {
    return (
        <div className={cn("flex justify-end items-center min-w-[70px]", className)}>
            <div
                className={cn(buttonVariants({ variant: locked ? "ghost" : "secondary", size: "icon" }), "p-0 ml-auto")}
                tabIndex={-1}
                aria-hidden="true"
            >
                {locked ? <Lock size={20} /> : <Pencil size={20} />}
            </div>
        </div>
    );
}
